/**
 * Create tab stack – main create flow and match details pushed on top.
 * Same pattern as friends: list -> tap card -> stack pushes group leaderboard / match details.
 * contentStyle.backgroundColor matches screen background to avoid white flash during push/pop.
 * Wrapped in FriendsPageProvider so the participants step can open Invite/Create modals (same as Friends tab).
 * CreatePageProvider is scoped here so it only mounts when the user is on the create tab (no hook leakage on Arena/Scoreboard).
 */

import { Stack } from 'expo-router';
import { useTheme } from '../../../src/theme/useTheme';
import { FriendsPageProvider } from '../../../src/friends/contexts/FriendsPageContext';
import { CreatePageProvider } from '../../../src/create/contexts/CreatePageContext';
import { InviteFriendsModal } from '../../../components/friends';

export default function CreateStackLayout() {
  const theme = useTheme();
  return (
    <FriendsPageProvider>
      <CreatePageProvider>
        <InviteFriendsModal />
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: theme.background.primary },
          }}
        />
      </CreatePageProvider>
    </FriendsPageProvider>
  );
}
